import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { compact } from "lodash";
import type { ReactNode } from "react";

import { useAppendBodyClasses } from "@/react/hooks/useAppendBodyClasses";

interface Props {
  bodyClassNames?: string;
  children?: ReactNode;
  title?: string | null;
}

export const PageMetaData = ({
  title,
  bodyClassNames = "",
  children,
}: Props) => {
  const { currentCommunity } = usePunditUserContext();
  const fullTitle = compact([title, currentCommunity?.name]).join(" | ");
  useAppendBodyClasses(bodyClassNames);
  return (
    <>
      <title>{fullTitle}</title>

      {children}
    </>
  );
};
